/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { apiResponseV4Schema } from './apiResponseV4Schema'
import { switchOrgRequestV4Schema } from './switchOrgRequestV4Schema'
import { switchOrgResponseV4ApiResponseObjectV4Schema } from './switchOrgResponseV4ApiResponseObjectV4Schema'

export const authSwitchStatus200Schema = switchOrgResponseV4ApiResponseObjectV4Schema.describe(
  'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
)

export const authSwitchStatus400Schema = apiResponseV4Schema.describe(
  'V4 response envelope — same contract as the legacy EP.Models.ViewModels.ApiResponse minus the dead\r\n`planNeeded` field. V4 endpoints must never expose `planNeeded`; legacy endpoints keep\r\nthe old envelope untouched.'
)

export const authSwitchResponseSchema = authSwitchStatus200Schema

export const authSwitchErrorSchema = authSwitchStatus400Schema

export const authSwitchBodySchemaJsonPatchJson = switchOrgRequestV4Schema.optional()

export const authSwitchBodySchemaJson = switchOrgRequestV4Schema.optional()

export const authSwitchBodySchemaJson2 = switchOrgRequestV4Schema.optional()

export const authSwitchBodySchemaJson3 = switchOrgRequestV4Schema.optional()

export const authSwitchBodySchema = z.union([
  authSwitchBodySchemaJsonPatchJson,
  authSwitchBodySchemaJson,
  authSwitchBodySchemaJson2,
  authSwitchBodySchemaJson3,
])
